import Headroom from "headroom.js";


if (Headroom.cutsTheMustard) {
    // select your header or whatever element you wish
    const header = document.querySelector("header");
    const search = document.querySelector("#search-bar");

    var options = {
        // vertical offset in px before element is first unpinned
        offset: 60
    }

    const headroom = new Headroom(header, options);
    headroom.init();

    const search_headroom = new Headroom(search, options);
    search_headroom.init();


    jQuery(document).ready(function ($) {
        // FAQ navigation
        if ($('#section__faq-nav').length) {
            var faqNav = document.getElementById('section__faq-nav');
            var headroomFaqNav = new Headroom(faqNav);
            headroomFaqNav.init();
        }
    });
}

